<template>
  <div></div>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    layout: 'layout-exterior',
    beforeMount() {
      this.$router.push('/Solidarmed/IL');
    },
  });
</script>
